import React from "react";
import { MdArrowBack, MdChatBubble, MdLocalShipping, MdSecurity, MdShoppingCart } from "react-icons/md";
import { formatRupiah, getDiscount, getFinalPrice, getProductImage } from "../../utils/ecommerce";
import ProductCard from "../../components/ProductCard";

const DetailPage = ({
  selectedBarang,
  selectedImageIndex,
  setSelectedImageIndex,
  quantity,
  setQuantity,
  backToHome,
  addToCart,
  buyNow,
  getAskProductWhatsappUrl,
  relatedProducts = [],
  openProduct,
}) => {
  if (!selectedBarang) {
    return <div className="catalog-state">Produk tidak ditemukan.</div>;
  }

  const discount = getDiscount(selectedBarang);
  const images =
    selectedBarang.barangfotos?.length > 0
      ? selectedBarang.barangfotos
      : [{ linkGambar: getProductImage(selectedBarang) }];

  return (
    <main className="page-container">
      <div className="breadcrumb">
        AJS Ecommerce &gt; {selectedBarang.kategori?.nama || "Elektronik"} &gt;{" "}
        {selectedBarang.nama}
      </div>
      <section className="detail-panel">
        <div className="gallery">
          <img
            className="gallery-main"
            src={getProductImage(selectedBarang, selectedImageIndex)}
            alt={selectedBarang.nama}
          />
          <div className="gallery-thumbs">
            {images.map((foto, index) => (
              <button
                key={foto.id || index}
                className={selectedImageIndex === index ? "active" : ""}
                type="button"
                onClick={() => setSelectedImageIndex(index)}
              >
                <img src={foto.linkGambar} alt={`${selectedBarang.nama} ${index + 1}`} />
              </button>
            ))}
          </div>
        </div>
        <div className="detail-info">
          <button className="back-link" type="button" onClick={backToHome}>
            <MdArrowBack /> Kembali
          </button>
          <h1>
            {selectedBarang.isFlashsale && <span>Promo</span>}
            {selectedBarang.nama}
          </h1>
          <div className="rating-row">
            <b>4.8</b>
            <span className="stars">*****</span>
            <i>2,5RB Penilaian</i>
            <i>{selectedBarang.kuantitasTerjual || 0} Terjual</i>
          </div>
          <div className="detail-price">
            {formatRupiah(getFinalPrice(selectedBarang))}
            {discount > 0 && (
              <>
                <small>{formatRupiah(selectedBarang.hargaJual)}</small>
                <b>-{discount}%</b>
              </>
            )}
          </div>
          <div className="detail-stock">
            {Number(selectedBarang.stok || 0) > 0
              ? `Stok Tersedia (${selectedBarang.stok})`
              : "Stok Habis"}
          </div>
          {Number(selectedBarang.minimalQtyGrosir || 0) > 0 &&
            Number(selectedBarang.hargaGrosir || 0) > 0 && (
              <div className="wholesale-box">
                Harga grosir {formatRupiah(selectedBarang.hargaGrosir)} / pcs
                berlaku mulai {selectedBarang.minimalQtyGrosir} pcs.
              </div>
            )}
          <div className="benefit-row">
            <div>
              <MdLocalShipping /> Garansi tiba besok
            </div>
            <div>
              <MdSecurity /> Produk dijamin aman
            </div>
          </div>
          <div className="variant-block">
            <label>Merk</label>
            <button type="button">{selectedBarang.merk?.nama || "AJS"}</button>
            <button type="button">{selectedBarang.kategori?.nama || "Elektronik"}</button>
          </div>
          <div className="quantity-row">
            <label>Kuantitas</label>
            <button type="button" onClick={() => setQuantity(Math.max(1, quantity - 1))}>
              -
            </button>
            <span>{quantity}</span>
            <button type="button" onClick={() => setQuantity(quantity + 1)}>
              +
            </button>
          </div>
          <div className="detail-actions">
            <button className="outline-action" type="button" onClick={() => addToCart(selectedBarang, quantity)}>
              <MdShoppingCart /> Masukkan Keranjang
            </button>
            <button className="solid-action" type="button" onClick={() => buyNow(selectedBarang)}>
              Beli Sekarang
            </button>
          </div>
          <a
            className="ask-wa-button"
            href={getAskProductWhatsappUrl(selectedBarang)}
            target="_blank"
            rel="noreferrer"
          >
            <MdChatBubble /> Tanya via WhatsApp
          </a>
        </div>
      </section>
      <section className="description-panel">
        <h2>Deskripsi Produk</h2>
        <p>{selectedBarang.deskripsi || "Produk elektronik pilihan AJS Ecommerce."}</p>
        <div className="spec-grid">
          <div>
            <span>Kategori</span>
            <b>{selectedBarang.kategori?.nama || "-"}</b>
          </div>
          <div>
            <span>Merk</span>
            <b>{selectedBarang.merk?.nama || "-"}</b>
          </div>
          <div>
            <span>SKU</span>
            <b>{selectedBarang.kode || "-"}</b>
          </div>
        </div>
      </section>
      {relatedProducts.length > 0 && (
        <section className="related-panel">
          <div className="section-title">
            <h2>Produk Terkait</h2>
            <div className="line" />
          </div>
          <div className="flash-all-grid">
            {relatedProducts.map((barang) => (
              <ProductCard barang={barang} key={barang.id} onOpen={openProduct} />
            ))}
          </div>
        </section>
      )}
    </main>
  );
};

export default DetailPage;
